import Swiper from 'swiper/bundle';

let swiper_gallery = new Swiper('.swiper-gallery', {
  loop: true,
  autoplay: {
    delay: 1500,
    disableOnInteraction: false,
  },
  speed: 1200,
  slidesPerView: 'auto',
  spaceBetween: 15,
});
